import React, { useState} from 'react';
import './App.css';

// App
function App() {
  
  return (
    <div className="viewport">
    {/* Full Bleed Background */}
    <div className="video-container">
        <div className="video-overlay"></div>
        {/* Drop in your full-bleed video URL below */}
        <video aria-hidden="true" autoPlay muted loop playsInline poster="fb-static-bg.jpg">
            <source src="fb.mp4" type="video/mp4" />
            <img src="fb-static-bg.jpg" alt="Fallback background asset" />
        </video>
    </div>

    <header>
        <div className="logo">Rock<span>-</span>It<span>.</span><i>ai</i><img class="rock-it-logo" width="50" height="55" src="logo.webp" alt="rock-it.ai logo"/></div>
        <div className="cta-group">
            <a className="btn btn-booking" href="mailto:hi@rock-it.ai?subject=Project%20Briefing%20Request%20-%20[Your%20Name]- %20[Your%20Company]">Email A Specialist</a>
        </div>
    </header>

    <main className="main-hero">
        <h1>Engineering the Future of Flow: <br/>Your Vision, Accelerated</h1>
        <h2>Human Intelligence Empowered by AI. Rock<span>-</span>It<span>.</span><i>AI</i> delivers:</h2>
    </main>

    <section className="solution-grid">
        <div className="solution-card">
            <h2>Accelerate Your Innovation Pipeline... <i>Deliver more</i></h2>
            <h3>From Concept to Market-Ready Solution in Record Time, Without Compromising Quality.</h3>
            <p>Velocity is your greatest asset. We use elite Product Engineering, SRE, and Platform Engineering skills to help Teams, Orgs and Product Owners bring projects to market rapidly, reliably and cost-effectively.</p>
            <img src="4.jpg" width="962" height="524" alt="Seamless Interconnectivity" /> 
        </div>
        <div className="solution-card">
            <h2>Build Lasting Client & Customer Connections... <br/><i>Create value</i></h2>
            <h3>Reduce Churn, Boost ROI and Grow through High-Performance Experiences.</h3>
            <p>Client satisfaction underpins our mutual success. We only deliver to the highest standards and obsess over quality. Partner with us, deliver projects that 'wow' and unlock deeper customer lifecycle value.</p>
            <img src="5.jpg" width="962" height="524" alt="Mission-Critical Reliability" />                       
        </div>
        <div className="solution-card">
            <h2>Deliver Projects with Robust Reliability... <br/><i>Reduce Risk</i></h2>
            <h3>Secure your organisation, move toward digital maturity and protect your brand.</h3>
            <p>Our trusted partner relationship is built upon secure foundations that lower exspoure to risk. We reduce your governance bottlenecks and apply the right security standards, controls and GDPR into everything we build.</p>
            <img src="6.jpg" width="962" height="524" alt="Optimal Capital Efficiency" />                         
        </div>
    </section>

    <ToggleSection />

    <Footer />
  </div>
  );
}

// 2. Toggle Section (Founder vs Contact)
function ToggleSection() {  
    const [view, setView] = useState('founder');

    return (
        <section className="container">
            <div className="toggle-container">
                <button className={`toggle-btn ${view === 'founder' ? 'active' : ''}`} onClick={() => setView('founder')}>Design Values</button>
                <button className={`toggle-btn ${view === 'contact' ? 'active' : ''}`} onClick={() => setView('contact')}>Get Started</button>
            </div>

            {view === 'founder' ? (
                <div className="reveal is-visible">
                    <div className="reveal-area">
                      <img src="colin-humphrey.jpeg" alt="founder" />                     
                    </div>
                    <div>
                        <h2 style={{fontSize: '2.5rem'}}>Rock<span>-</span>It<span>.</span><i>AI</i>: DNA and Vision</h2>
                        <blockquote style={{borderLeft: '4px solid var(--primary)', paddingLeft: '20px', margin: '20px 0', fontStyle: 'italic', color: '#ccc'}}>
                            "We aren't just building software or infrastructure; we're building the ideas, products and brands of the future, today.  Go beyond!", Colin Humphrey
                        </blockquote>         
                        <section className="about-company-detail">
                            <p>Rock<span>-</span>it<span>.</span><i>AI</i> is not another off-the-shelf, by the numbers cookie-cutter agency; we are your strategic engineering partner in an era of AI dominance & evolving technology.  We drive impactful solutions where today's choices lead to tomorrow's make-or-break outcomes. In the ever changing fast world of rapid digital evolution we specialise in removing the friction between legacy components, workflows and architecture that often stifle innovation and success.</p><br/><p>We bridge the gap between ambitious vision, products, projects and balance those outcomes with realistic deadlines and minimise exposure to risk.  We apply guard rails and engineer robust reliability at scale.  We apply governance and compliance into every client relationship and meet you where you are. We harmonise elite 'human intelligence' with depth of experience, expertise and implement our Agentic AI and other AI offerings only when it makes sense to do so.  We don't reinvent the wheel.</p>
                            {/* <br/>
                            <p>We help you navigate tensions of cost centres, Capex and Opex, unblocking technical bottlenecks to unlock new value chains. Whether you are an agency, local authority, high-growth brand or product, well known person or charity we provide the maturity and build upon compliant standards from GDPR, ISO27001, PCI-DSS, SOC-1, SOC-2.  We build according to strict OKRs, KPIs, SLOs backed by our own Deveoper metrics based on DORA.  We allow you to move forward with absolute confidence.  We deliver your vision without compromise and deliver your goals.  We are a nimble, remote first and work with the right specialists at point of need and put boots on the ground when required.  Our footprints and overheads are low and we pass these savings onto our clients.  We are growing our clients and engagements so for a limited time period can offer a discretionary discount.</p> */}
                            {/* <p>With over 15 years in building products, websites & platforms, our founder has scaled platforms for some of the world's most aggressive tech giants.</p> */}
                        </section>       
                    </div>
                </div> 
            ) : (
                <div className="form is-visible" style={{maxWidth: '600px', margin: '0 auto'}}>
                    <GoogleContactForm />                  
                </div>
            )}
        </section>
    );
}

function GoogleContactForm() {
  // State to track if the form was successfully sent
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSending, setIsSending] = useState(false);

  async function handleFormSubmit(e) {
    e.preventDefault();
    setIsSending(true);

    const formData = new FormData(e.target);

    // 1. Anti-Abuse Check (Honeypot)
    if (formData.get('honeypot')) {
      console.warn("Honeypot filled. Submission ignored.");
      return;
    }

    // 2. Prepare Data (Replace YOUR_FORM_ID with the actual ID)
    const actionUrl = "https://script.google.com/macros/s/AKfycbxe_9pNiRZHkGAYRQJvJjjDagRBJceRVyOx1F21Rx08XzpPWb1bFWCX0O4zanDOcBD0-Q/exec";

    // 3. Post to Google
    try {
      await fetch(actionUrl, {
        method: 'POST',
        mode: 'no-cors', // Keeps the user on the current page
        body: formData
      });

      // 4. Update UI state instead of direct DOM manipulation
      setIsSubmitted(true);
    } catch (error) {
      alert("Submission failed. Please check your connection.");
      console.error("Form error:", error);
    } finally {
      setIsSending(false);
    }
  }

  // Define the Success View
  if (isSubmitted) {
    return (
      <div id="success-msg">
        <h3 style={{marginBottom: '20px'}}>Thank You for Your Interest</h3>
        <p style={{color: '#ccc'}}>Thanks for getting in touch! We’ve received your details and our team will get back to you shortly.</p>
      </div>
    );
  }

  // Define the Form View
  return (
    <div id="form-wrapper">
      <form id="customGoogleForm" onSubmit={handleFormSubmit}>
        {/* Replace entry.XXXXXX with your actual IDs from the Page Source */}
        <input name="name" type="text" placeholder="Your Name" required />
        <input name="email" type="email" placeholder="Email Address" required />
        <textarea name="message" placeholder="Tell us what you would like to achieve?" rows="5"></textarea>
        {/* Honeypot Field - Hidden from users */}
        <input 
          type="text" 
          name="honeypot" 
          style={{ display: 'none' }} 
          tabIndex="-1" 
          autoComplete="off" 
        />

        <button className="btn btn-primary submit" type="submit" disabled={isSending}>
          {isSending ? "3, 2, 1 Sending..." : "Submit to Rock-It.AI"}
        </button>
      </form>
    </div>
  );
}

// Footer
function Footer() {
  return (
    <footer>
        <div className="container">
            <div className="brand">Rock<span>-</span>It<span>.</span><i>AI</i></div>
            <p>© 2026 Rock<span>-</span>It<span>.</span><i>AI</i> Engineered in London by cadava.com.</p>
        </div>
    </footer>
  );
}

export default App;
